'use strict';

import VZAddBase from './VZAddBase';
import { scrollToElement } from '../../../util/domUtils';
import { handleTransition } from 'Util/transitions.js';

export default class VZAddDevice extends VZAddBase {
    constructor() {
        super();
        this.configuratorType = document.querySelector('[data-configurator-type]').dataset.configuratorType;
        this.addDeviceBtn = this.querySelector('.js-add-device');
        this.devicesContainer = document.querySelector('.js-hardware-device-cards');
        this.devicesCards = document.querySelectorAll('.js-hardware-device-card');
        this.bmQuantityCard = document.querySelector('.js-business-mobile-quantity-card');
        this.addSimsLinks = document.querySelectorAll('.js-add-sims-link');
        this.addDevicesLink = document.querySelector('.js-add-devices-link');
    }

    connectedCallback() {
        if (this.configuratorType === 'business-mobile') {
            this.onClick = this.onClick.bind(this);
            if (this.addDeviceBtn) {
                this.addDeviceBtn.addEventListener('click', this.onClick);
            }
        }
        this.toggleVisiblity();

        // Scroll to BM Quantity Card
        this.addSimsLinks?.forEach((link) => {
            link.addEventListener('click', (event) => {
                event.preventDefault();
                scrollToElement(this.bmQuantityCard);
            });
        });

        // Keep last card open after sorting & filtering
        document.querySelector('#product-configurator')?.addEventListener('pdp:sorting', () => {
            this.addNewDevice();
        });
        document.querySelector('#product-configurator')?.addEventListener('pdp:filter', () => {
            this.addNewDevice();
        });
    }

    disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
    }

    toggleVisiblity() {
        if ([...this.devicesCards].some((card) => !card.classList.contains('is-configured') && card.classList.contains('d-none'))) {
            this.classList.remove('d-none');
        } else {
            this.classList.add('d-none');
        }
    }

    /**
     * @function onClick
     * @description Handles the onClick
     */
    onClick() {
        handleTransition(() => {
            this.addNewDevice();
        });
    }

    addNewDevice() {
        // Collapse previous card
        [...this.devicesCards].forEach((card) => {
            if (!card.classList.contains('is-collapsed')) {
                card.classList.add('is-collapsed');
            }
        });

        const lastDeviceCard = this.devicesCards[this.devicesCards.length - 1];
        if (lastDeviceCard && lastDeviceCard.classList.contains('d-none')) {
            lastDeviceCard.classList.remove('d-none');
        }

        // Update this.devicesCards to include the newly added device
        this.devicesCards = document.querySelectorAll('.js-hardware-device-card');
        this.toggleVisiblity();

        // Scroll to the lastDeviceCard
        if (lastDeviceCard) {
            scrollToElement(lastDeviceCard);
        }
    }
}

if (!window.customElements.get('vz-add-device')) {
    window.customElements.define('vz-add-device', VZAddDevice);
}
